import React, { createContext, useCallback, useContext, useState } from 'react';
import { Button } from '../components/ui/Button';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  const confirm = useCallback((options) => {
    const opts = typeof options === 'string' ? { message: options } : options;
    return new Promise((resolve) => {
      setState({
        title: opts.title || 'Confirm',
        message: opts.message || '',
        confirmLabel: opts.confirmLabel || 'Confirm',
        cancelLabel: opts.cancelLabel || 'Cancel',
        danger: opts.danger || false,
        resolve,
      });
    });
  }, []);

  const close = (result) => {
    if (state?.resolve) state.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state && (
        <div className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center p-4 bg-black/40">
          <div className="w-full max-w-md rounded-xl bg-card p-6 shadow-card border border-border">
            <h3 className="text-lg font-semibold text-text">{state.title}</h3>
            <p className="mt-2 text-sm text-muted">{state.message}</p>
            <div className="mt-6 flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
              <Button variant="secondary" className="w-full sm:w-auto" onClick={() => close(false)}>
                {state.cancelLabel}
              </Button>
              <Button
                variant={state.danger ? 'danger' : 'primary'}
                className="w-full sm:w-auto"
                onClick={() => close(true)}
              >
                {state.confirmLabel}
              </Button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
  return ctx;
}
